import { ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION, ANY_AUTO_BRAND_INCOMING_ITEM } from 'constants/dictionaries';

import type { TAutoBrand, TAutoInfo } from 'shared/types';

export function isBrandValid(brand: TAutoBrand | undefined): brand is NonNullable<TAutoBrand>;
export function isBrandValid(brand: TAutoInfo['brand'] | undefined): brand is NonNullable<TAutoInfo['brand']>;
export function isBrandValid(
  brand: TAutoBrand | TAutoInfo['brand'] | undefined,
): brand is NonNullable<TAutoBrand | TAutoInfo['brand']> {
  return !!brand?.id && !!brand?.alias && !!brand?.name;
}

export function mapBrand(brand: NonNullable<TAutoBrand>): Dictionaries.TSelectOption<number, NonNullable<TAutoBrand>>;
export function mapBrand(
  brand: NonNullable<TAutoInfo['brand']>,
): Dictionaries.TSelectOption<number, NonNullable<TAutoInfo['brand']>>;
export function mapBrand({
  id,
  name,
  ...data
}: NonNullable<TAutoBrand | TAutoInfo['brand']>): Dictionaries.TSelectOption<
  number | string,
  NonNullable<TAutoBrand | TAutoInfo['brand']>
> {
  if (ANY_AUTO_BRAND_INCOMING_ITEM.id === id) {
    return ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION;
  }

  return {
    value: Number(id),
    label: String(name),
    data: { ...data, id, name } as NonNullable<TAutoBrand | TAutoInfo['brand']>,
  };
}

export function mapBrands(brands?: TAutoBrand[]): Array<Dictionaries.TSelectOption<number, NonNullable<TAutoBrand>>>;
export function mapBrands(
  brands?: Array<TAutoInfo['brand']>,
): Array<Dictionaries.TSelectOption<number, NonNullable<TAutoInfo['brand']>>>;
export function mapBrands(
  brands?: Array<TAutoBrand | TAutoInfo['brand']>,
): Array<Dictionaries.TSelectOption<number | string, NonNullable<TAutoBrand | TAutoInfo['brand']>>> {
  return brands?.filter(isBrandValid)?.map(mapBrand) ?? [];
}
